export default function Services() {
  return (
    <section className="service section" id="services">
      <div className="container">
        <div className="row">
          <div className="section-title padd-15">
            <h2>Services</h2>
          </div>
        </div>
        <div className="row">
          <div className="service-item padd-15">
            <div className="service-item-inner">
              <h4>Motion Graphics</h4>
              <p>
                Engage your audience with eye-catching motion graphics that make
                your message unforgettable. From promos to explainer videos, we
                bring ideas to life with style and impact. Let’s create
                something amazing!
              </p>
            </div>
          </div>
          <div className="service-item padd-15">
            <div className="service-item-inner">
              <h4>3D Modeling</h4>
              <p>
                Bring your vision to life with our 3D modeling services. From
                product designs to architectural renderings, we craft realistic
                and detailed models that make ideas tangible and captivating.
                Let's build something extraordinary together!
              </p>
            </div>
          </div>
          <div className="service-item padd-15">
            <div className="service-item-inner">
              <h4>3d Animation</h4>
              <p>
                Elevate your visuals with our 3D animation services. We turn
                concepts into lifelike animations that captivate and
                communicate, perfect for marketing, product demos, and
                storytelling. Let’s bring your ideas to motion!
              </p>
            </div>
          </div>
          <div className="service-item padd-15">
            <div className="service-item-inner">
              <h4>VFX</h4>
              <p>
                Add stunning visual effects with our VFX services. We create
                immersive, high-quality effects that transform ordinary scenes
                into extraordinary experiences. Make your vision unforgettable
                with our expertise in VFX!
              </p>
            </div>
          </div>
          <div className="service-item padd-15">
            <div className="service-item-inner">
              <h4>Graphics Designing</h4>
              <p>
                Enhance your brand with our graphic design services. From logos
                to marketing materials, we create striking visuals that capture
                attention and communicate your message effectively. Let's make
                your brand unforgettable!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
